import type { FieldKey } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';
import { createGetOptionLabel } from './options.tsx';
import { createHigherLevelIssueHook2 } from './utils.tsx';

export const useOptionLabel = createHigherLevelIssueHook2<FieldKey, string, string | undefined>(
	createGetOptionLabel,
);
